import { IonThumbnail, IonList, IonRefresherContent, IonRefresher, IonChip, IonAvatar, IonNote, IonIcon, useIonRouter, useIonViewWillEnter, IonGrid, IonCol, IonRow, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { chevronForwardOutline } from 'ionicons/icons';

import { showTab, updateTab } from "../components/Tabs";
import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { ItemInfo } from "../data/item";

import './Main.css'; 

const Studio : React.FC = () => {

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    const [channel, setChannel] = useState(-1);
    const [channelTitle, setChannelTitle] = useState("");
    const [channelAvatar, setChannelAvatar] = useState("");
    const [channelDesc, setChannelDesc] = useState("");
    const [channelCategory, setChannelCategory] = useState("");
    const [videoList, setVideoList] = useState<ItemInfo[]>([]);

    // reload the data
    const getData = async () => {
        // upload the content
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

        var server = new NServer();
        await server.getList("nc_studio", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }

        setChannel(server.data.channel);
        setChannelTitle(server.data.ch_title);
        setChannelAvatar(server.data.ch_avatar);
        setChannelDesc(server.data.ch_code);
        setChannelCategory(server.data.ch_category);
        setVideoList(server.data.videos);

        updateTab();

        if (server.data.channel < 0)
        {
            // ask user to create a new channel
            router.push("/new_channel/-1", "back", "pop");
        }
    }

    // edit a channel
    const editCurChannel = () => {
        router.push("/channel_info/" + channel, "forward", "push");
    }   

    // manager all channels
    const manageChannels = () => {
        router.push("/channel_list/edit", "forward", "push");
    }   

    // refresh event
    const doRefresh = async (ev : any) => {
        await getData();
        ev.detail.complete();
    };

    // view the content
    const viewContent = (id : number) => {
        router.push("/video/" + id, "forward", "push");
    }

    // add a new video
    const addNewVideo = () => {
        router.push("/add/select", "back", "pop");
    }

    return (
        <IonPage>
            <IonHeader>
                <IonItem lines="none"></IonItem>
            </IonHeader>
            <IonContent>
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <div id="border-bk" />
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                            <div className="ion-padding-start ion-padding-top">{ GetStr(LANGUAGE.TXT_YOUR_CHANNEL) }</div>
                            <IonCard>
                                <IonItem lines="none" routerLink="/channel_list/select">
                                    <IonAvatar slot="start">
                                        <img src={channelAvatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/channel.png' } } />
                                    </IonAvatar>
                                    <IonLabel className="ion-text-wrap">
                                        <h2>{channelTitle}</h2>
                                        <IonNote>{channelCategory}</IonNote>
                                    </IonLabel>
                                    <IonIcon slot="end" icon={chevronForwardOutline}/>
                                </IonItem>
                            </IonCard>
                            <div className="ion-padding-start">
                                <IonChip onClick={editCurChannel}>{ GetStr(LANGUAGE.TXT_CH_EDIT_BUT) }</IonChip>
                                <IonChip onClick={manageChannels}>{ GetStr(LANGUAGE.TXT_CH_EDIT_ALL_BUT) }</IonChip>
                            </div>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <div className="ion-padding-start ion-padding-top">{ GetStr(LANGUAGE.TXT_YOUR_VIDEOS) }</div>
                            <IonCard>
                                {
                                    videoList.length == 0 ?
                                <div className="ion-padding ion-text-center">
                                    <div><i>{ GetStr(LANGUAGE.TXT_CH_NO_VIDEO) }</i></div>
                                    <div className="ion-padding-top"><IonChip onClick={addNewVideo}>{ GetStr(LANGUAGE.TXT_CH_ADD_NO_VIDEO) }</IonChip></div>
                                </div>
                                    :
                                <IonList>
                                    {
                                        videoList.map(m => 
                                            <IonItem key={m.id} detail={false} lines="none" onClick={()=> viewContent(m.id)}>
                                                <IonThumbnail slot="start">
                                                    <img src={m.avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/rect_pic.png' } } />
                                                </IonThumbnail>
                                                <IonLabel className="ion-text-wrap">
                                                    <h2>{m.name}</h2>
                                                    <IonNote>{m.info}</IonNote>
                                                </IonLabel>
                                                <IonIcon slot="end" icon={chevronForwardOutline}/>
                                            </IonItem>
                                    )}
                                </IonList>
                                }
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Studio;